<label [for]="id" [ngClass]="['control-label', _labelClass]">Antenne&nbsp;{{ _mandatory? '*' : '' }}:</label>
<div [ngClass]="_fieldClass">
	<div class="input-group col-sm-12 ng-scope">
	 	<select  [name]="id" [id]="id"
	 		[disabled]="disabled"
			[(ngModel)]="_selectedAntenneId"
			(ngModelChange)="onSelectionChange()"
			class="form-control" 
			>
			<option *ngIf="wildcardOptionLabel && antennes && antennes.length > 1" [ngValue]="null" class="tip">{{ wildcardOptionLabel }}</option>
			<option *ngFor="let antenne of antennes" [ngValue]="antenne.id">{{ antenne.nom }}</option>
		</select>
		<div class="input-group-addon">
			<a class="" href="#" onclick="return false;" title="Retirer le choix d'antenne" (click)="onCancelSelection()">
				<span [ngClass]="'fa fa-minus-circle fa-lg' + (disabled ? ' disabled' : '' )"></span>
			</a>
		</div>
	</div>
</div>